var React = require('react');

function CaretDown (props) {
    return React.createElement("svg",props,[React.createElement("desc",{"key":0},"Created with Sketch."),React.createElement("defs",{"key":1}),React.createElement("g",{"id":"All","stroke":"none","strokeWidth":"1","fillRule":"evenodd","key":2},React.createElement("g",{"id":"GUI_part-(v2)","transform":"translate(-1800.000000, -912.000000)","fillRule":"nonzero"},React.createElement("path",{"d":"M1807.44975,915.449747 L1806.44975,916.449747 L1806.44975,915.449747 L1807.44975,915.449747 Z M1806.44975,910.449747 L1808.44975,910.449747 L1808.44975,917.449747 L1801.44975,917.449747 L1801.44975,915.449747 L1806.44975,915.449747 L1806.44975,910.449747 Z","id":"Dropdown_arrow","transform":"translate(1804.949747, 913.949747) rotate(-315.000000) translate(-1804.949747, -913.949747) "})))]);
}

CaretDown.defaultProps = {"width":"10px","height":"7px","viewBox":"0 0 10 7","version":"1.1"};

module.exports = CaretDown;

CaretDown.default = CaretDown;
